// 引入 axios
import axios from 'axios'
import CryptoJS from "crypto-js"
import { ORIGIN_LIST } from './origin'




const createRequest = (baseURL, accessKey, secretKey) => {
    axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8"

    if (accessKey) {
        axios.defaults.headers["X-Sys-App-Key"] = accessKey
    }
    const requests = axios.create({
        // 配置基础路径
        baseURL: baseURL,
        timeout: 100 * 1000,
    })

    // 配置拦截器
    requests.interceptors.request.use(config => {
        if (accessKey && secretKey) {
            const timekey = Math.round(new Date().getTime())
            config.headers["X-Sys-App-Sign"] = CryptoJS.MD5(accessKey + secretKey + timekey)
                .toString(CryptoJS.enc.Hex)
                .toLowerCase()
            config.headers["X-Sys-Requsest-Time"] = timekey
        }

        // 请求带token
        /* config.headers.Authorization = window.sessionStorage.getItem('token') */
        return config
    })

    // 对应拦截器
    requests.interceptors.response.use((res) => {
        // 请求成功的回调函数
        return res.data;
    }, () => {
        // 请求失败的回调函数
        return Promise.reject('fail')
    })

    return requests
}



// 对外暴露
export default createRequest('/zhong-jia-index');



const createHttp = () => {
    const requests = {}
    ORIGIN_LIST.forEach(item => {
        if (item.type === '3.0') {
            requests[item.name] = createRequest(item.baseUrl, item.accessKey, item.secretKey)
        }
    });
    return requests
}

const requests = createHttp()

export {
    createRequest,
    requests
}

